var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"live-record",attrs:{"element-loading-text":"视频加载中..."}},[_c('video',{ref:"videoRef",attrs:{"src":_vm.video_url,"preload":"auto","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }